import React from 'react';
import Footer from './Footer';
import {Col, Container, Row} from 'react-bootstrap';
import logoCleanbill from '../assets/img/logo_cleanbill.png';
import {TitleButton} from './Header';
import ScrollableAnchor from 'react-scrollable-anchor';
import waveGroup from '../assets/img/wave_group.png';
import styled from 'styled-components';


const Content = styled.div`
  padding-top: 90px;
`;

const ContainerWave = styled(Container)`
  &&&& {
    padding-bottom: 300px;
  }
`;


const NotFoundPage = ({history}) => {
  return (
    <div className="homepage-section">
      <Container className="header">
        <Row className="burger-menu">
          <Col xs={6} className="burger-logo-col">
            <div>
              <img src={logoCleanbill} alt="cleanbill-logo" className="burger-cleanbill-logo" />
            </div>
          </Col>
        </Row>
        <Row className="full-header">
          <Col xs={12} className="full-header-list">
            <div>
              <img src={logoCleanbill} alt="cleanbill-logo" className="header-cleanbill-logo" />
            </div>
            <div className="items-list">
              <TitleButton className="menu-item" to="/login">
                Mon compte
              </TitleButton>
            </div>
          </Col>
        </Row>
      </Container>

      <Content>
        <ScrollableAnchor id={'presentation'}>
          <ContainerWave className="container-full presentation-container">
            <img src={waveGroup} className="wave-background" alt="Waves background"/>
            <div className="container-error-comp-not-found">
              <h3 className="title-not-found">404</h3>
              <h3 className="subtitle-not-found">Page non trouvée</h3>
              <p className="text-not-found">La page que vous cherchez n'existe pas ou a été déplacée</p>
              <div className="btn-go-back__container d-flex justify-content-center">
                <TitleButton className="menu-item btn-go-back" to="/">
                  Retourner à l'accueil
                </TitleButton>
              </div>
            </div>
          </ContainerWave>
        </ScrollableAnchor>
      </Content>
      <Footer />
    </div>
  );
};

export default (NotFoundPage);
